'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

// import { stat } from 'graceful-fs';
import routes from './submissions.routes';

export class SubmissionsComponent {
  /*@ngInject*/
  constructor($scope, $http, userService, baseConfigService, fetch, $state, $location, $timeout, $stateParams) {
    const vm = this;
    // Variables 
    this.$scope = $scope;
    this.$http = $http;
    this.$state = $state;
    this.fetch = fetch;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;

    // Services 
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    $scope.baseUrl = baseConfigService.getBaseURL();

    $scope.Math = Math;
    $scope.pageSize = 10; // Default page size
    $scope.displayedCollection = [];

    this.excludedPolicies = [
      'Commercial Office Data Verification',
      'Residential Density Data Verification'
    ];

    $scope.updatePageSize = function () {
      console.log('Page size changed to:', $scope.pageSize)
      $scope.currentPage = 1; //Reset to the first page whenever the page size changes
      $scope.setPage(1); // Set the current page to 1
    }

    $scope.getTotalPages = function () {
      // console.log('filteredResults:', $scope.filteredResults);
      if (!$scope.filteredResults) {
        return 0; // Return 0 if filteredResults is undefined
      }
      return Math.ceil($scope.filteredResults.length / $scope.pageSize);
    };

    $scope.setPage = function (page) {
      if (page >= 1 && page <= $scope.getTotalPages()) {
        $scope.currentPage = page;
        // Update displayed collection based on the current page and size
        const start = ($scope.currentPage - 1) * $scope.pageSize;
        const end = start + $scope.pageSize;
        $scope.displayedCollection = $scope.filteredResults.slice(start, end);
        console.log("displayedCollection:", $scope.displayedCollection);
      }
    };

    $scope.nextPage = function () {
      if ($scope.currentPage < $scope.getTotalPages()) {
        $scope.setPage($scope.currentPage + 1);
      }
    }


    $scope.prevPage = function () {
      if ($scope.currentPage > 1) {
        $scope.setPage($scope.currentPage - 1);
      }
    };

    $scope.getPages = function () {
      var pages = [];
      for (var i = 1; i <= $scope.getTotalPages(); i++) {
        pages.push(i);
      }
      return pages;
    };

    $scope.validateScore = function (item) {
      if (item.score < 0) {
        item.score = 0;
      }
      if (item.score > item.max_score) {
        item.score = item.max_score;
        console.warn('Score cannot exceed ' + item.max_score);
      }
    };

    $scope.updateScore = function (item) {
    // console.log('updateScore called for:', item);
    // console.log('Current user:', $scope.currentUser); 
    
    if (item.excludeFromScoring || !item.submitted_date) {
      console.log('Skipping update - excluded or no submission');
      return;
    }
    
    // Check for currentUser
    if (!$scope.currentUser || !$scope.currentUser.firstname || !$scope.currentUser.lastname) {
      console.error('Current user not available');
      return;
    }
    
    var scoreData = {
      submission_id: item.submission_id,
      score: parseInt(item.score) || 0,
      score_last_updated_by: `${$scope.currentUser.firstname} ${$scope.currentUser.lastname}`
    };
    
    // console.log('Sending score data:', scoreData);
    // console.log('score_last_updated_by value:', scoreData.score_last_updated_by); 
    
    fetch.updateItem('api/data/submissions/update-score', scoreData)
      .then(response => {
        // console.log('Full response object:', response);
        // console.log('Response data:', response.data);
        // console.log('Updated record:', response.data.updatedRecord);
        
        vm.$timeout(() => {
          // Check if response.data.updatedRecord exists
          if (response.data && response.data.updatedRecord) {
            // console.log('Updating item with:', response.data.updatedRecord);
            item.score = response.data.updatedRecord.score;
            item.score_last_updated_by = response.data.updatedRecord.score_last_updated_by;
            item.score_last_updated_date = response.data.updatedRecord.score_last_updated_date;
            // console.log('Updated item.score_last_updated_by:', item.score_last_updated_by); 
          } else {
            console.warn('No updatedRecord in response, updating manually');
            // Fallback - update with the data we sent
            item.score = scoreData.score;
            item.score_last_updated_by = scoreData.score_last_updated_by;
            item.score_last_updated_date = new Date();
          }
          console.log('Item after update:', item);
        });
      })
      .catch(err => {
        console.error('Error updating score:', err);
        console.error('Error details:', err.data);
        vm.$timeout(() => {
          $scope.error = 'Failed to update score';
        });
      });
  };

    /**
* Get list of jurisdictions
*/
    $scope.getJurisdictionList = function () {
      fetch.getAllItems('api/data/jurisdictions/list')
        .then(response => {

          $scope.organizations = response.data;
          console.log($scope.organizations);
          // $scope.jurisdiction = response.data[0].jurisdiction;
          // $scope.getStationAreaList($scope.jurisdiction);
        })
        .catch(err => {
          console.log(err);
        })
    }


    $scope.statuses = ['In Review', 'Needs Work', 'Not Compliant', 'Compliant', 'Pending'];
    $scope.selectedStatuses = {};
    $scope.selectedTypes = {};
    $scope.selectedPolicies = {};
    $scope.selectedJurisdictions = {};
    $scope.selectedStations = {};
    $scope.statusSearch = '';

    // $scope.showMoreInfo = function (row) {
    //   console.log(row);
    //   // Construct the URL based on row.submission_policy_type, jurisdiction, and sta_recid
    //   // const url = `/account/housing/housing_production?jurisdiction=${row.jurisdiction}&sta_recid=${row.sta_recid}`;
    //   // Navigate to the new URL
    //   // $location.url(url);
    //   $state.go(row.url, {
    //     jurisdiction: row.jurisdiction,
    //     sta_recid: row.sta_recid
    //   });
    // };

    $scope.getDisplayPolicyName = function (row) {
      const housingPolicyTypes = [
        'Affordable Housing Protection Policy 1',
        'Affordable Housing Protection Policy 2',
        'Affordable Housing Preservation Policy 1',
        'Affordable Housing Preservation Policy 2',
        'Affordable Housing Production Policy 1',
        'Affordable Housing Production Policy 2'
      ];

      // For housing policies, show only the housing_policy_name if it exists
      if (housingPolicyTypes.includes(row.submission_policy_name) && row.housing_policy_name) {
        return row.housing_policy_name;
      }

      return row.submission_policy_name; // Returns unchanged for all other submissions
    };


    $scope.showMoreInfo = function (row) {
      console.log(row);
      console.log("parking_form_id:", row.parking_form_id);
      console.log("stationaccess_form_id:", row.stationaccess_form_id);
      let stateName;
      let policyName = row.housing_policy_name || row.submission_policy_name; // Use housing_policy_name if available, otherwise submission_policy_name
      // console.log('Navigating with policyName:', policyName);
      // console.log('submission_policy_name:', row.submission_policy_name);
      // console.log('submission_policy_type:', row.submission_policy_type);

      switch (row.submission_policy_type) {
        case 'Parking':
          // Handle different parking policies
          if (row.submission_policy_name === 'Vehicle Parking Minimum') {
            stateName = 'vehicle_parking';
          } else if (row.submission_policy_name === 'Vehicle Parking Maximum') {
            stateName = 'vehicle_parking';
          } else if (row.submission_policy_name === 'Bicycle Parking Minimum') {
            stateName = 'bicycle_parking';
          } else if (row.submission_policy_name === 'Unbundled Parking') {
            stateName = 'parking_policies';
          } else if (row.submission_policy_name === 'Shared Parking') {
            stateName = 'parking_policies';
          } else if (row.submission_policy_name === 'Complementary Parking Management Policy') {
            stateName = 'parking_policies';
          } else {
            console.error('Unknown parking policy name:', row.submission_policy_name);
            return;
          }
          break;
        case 'Housing Production Policy':
          stateName = 'housing_production';
          break;
        case 'Housing Preservation Policy':
          stateName = 'housing_preservation';
          break;
        case 'Housing Protection Policy':
          stateName = 'housing_protection';
          break;
        case 'Housing Commercial Policy':
          stateName = 'commercial_stabilization';
          break;
        case 'Zoning':
          stateName = 'zoning_updates';
          break;
        case 'Station Area Access':
          if (row.submission_policy_name === 'Complete Streets Policy') {
            stateName = 'complete_streets';
          } else if (row.submission_policy_name === 'Project Prioritization') {
            stateName = 'complete_streets';
          } else if (row.submission_policy_name === 'Gap Analysis') {
            stateName = 'analysis_improvement_program';
          } else if (row.submission_policy_name === 'Mobility Hub Planning') {
            stateName = 'mobility_hub';
          } else {
            console.error('Unknown parking policy name:', row.submission_policy_name);
            return;
          }
          break;
        case 'Density':
          if (row.submission_policy_name === 'Minimum FAR Office') {
            stateName = 'commercial_uses';
          } else if (row.submission_policy_name === 'Maximum FAR Office') {
            stateName = 'commercial_uses';
          } else if (row.submission_policy_name === 'Minimum Density Residential') {
            stateName = 'residential_uses';
          } else if (row.submission_policy_name === 'Maximum Density Residential') {
            stateName = 'residential_uses';
          } else if (row.submission_policy_name === 'Residential Uses Data Verification') {
            stateName = 'residential_uses';
          } else if (row.submission_policy_name === 'Commercial Office Uses Data Verification') {
            stateName = 'commercial_uses';
          } else {
            console.error('Unknown parking policy name:', row.submission_policy_name);
            return;
          }
          break;
        default:
          console.error('Unknown submission type:', row.submission_policy_type);
          return; // Exit if the type is unknown
      }

      // Save filter state to localStorage before navigating
      $scope.saveFilterState();

      // Navigate with the policy name parameter to open the correct tab
      $state.go(stateName, {
        jurisdiction: row.jurisdiction,
        sta_recid: row.sta_recid,
        policyName: policyName  // Add the policy name parameter
      });
    };

    $scope.showChangeStatus = function (row) {
      console.log(row);
      $scope.updateMessage = row;
      $('#updateMessagesModal').modal('toggle');

    };

    // function to show messages by loading state.go(message-detail) with the submission_id as a parameter 
    $scope.showMessages = function (row) {
      console.log(row);
      $state.go('message-detail', {
        submissionId: row.submission_id,
        messageData: 'submissions',
        data: row
      });
    };

    $scope.updateSubmissionStatus = function (row, newStatus) {
      // Store original values in case we need to revert
      row.originalStatus = row.status;
      row.originalUpdatedBy = row.status_last_updated_by;
      row.originalUpdatedDate = row.status_last_updated_date;

      // Update the UI immediately
      row.status = newStatus;

      // Prepare the update data
      const updateData = {
        submission_id: row.submission_id, // or however you identify the submission
        status: newStatus
      };

      // Call API to update status
      fetch.updateItem('api/data/submissions/update-status', updateData)
        .then(response => {
          $timeout(() => {
            // Update the status_last_updated fields in the UI
            row.status_last_updated_by = `${$scope.currentUser.firstname} ${$scope.currentUser.lastname}`;
            row.status_last_updated_date = new Date(); // Current date

            // Optional: Show success message
            $scope.successMessage = 'Status updated successfully';

            // No need to reload - row is already updated in UI
          });
        })
        .catch(err => {
          console.error('Error updating status:', err);
          $timeout(() => {
            // Revert all fields if update failed
            row.status = row.originalStatus;
            row.status_last_updated_by = row.originalUpdatedBy;
            row.status_last_updated_date = row.originalUpdatedDate;
            $scope.error = 'Failed to update status';
          });
        });
    };

    $scope.updateMessageFn = function (form) {
      console.log($scope.updateMessage);

      // Assuming you have a way to get the notify_id for the message being updated
      var updateData = $scope.updateMessage;
      $scope.saving = true;

      fetch.updateItem(`api/data/update-message`, updateData)
        .then((responseReport) => {
          console.log(responseReport);
          $scope.updateMessage = {};
          // Optionally refresh the list of messages
          // getAllMessages();
          $('#updateMessagesModal').modal('toggle');
          $scope.saving = false;
        })
        .catch((err) => {
          console.log(err);
          $scope.saving = false;
          if (err.response && err.response.status === 403) {
            $state.go('/login');
          }
        });
    }

  }

  $onInit() {
    // Store reference to this for use in callback
    const self = this;

    this.loadSubmissions()
      .then(() => {
        // After submissions are loaded, try to restore filter state
        try {
          const savedFilterState = localStorage.getItem('submissionsFilterState');
          if (savedFilterState) {
            const filterState = JSON.parse(savedFilterState);

            // Restore filter selections
            self.$scope.selectedStatuses = filterState.selectedStatuses || {};
            self.$scope.selectedTypes = filterState.selectedTypes || {};
            self.$scope.selectedPolicies = filterState.selectedPolicies || {};
            self.$scope.selectedJurisdictions = filterState.selectedJurisdictions || {};
            self.$scope.selectedStations = filterState.selectedStations || {};

            // Restore search terms
            self.$scope.statusSearch = filterState.statusSearch || '';
            self.$scope.typeSearch = filterState.typeSearch || '';
            self.$scope.policySearch = filterState.policySearch || '';
            self.$scope.jurisdictionSearch = filterState.jurisdictionSearch || '';
            self.$scope.stationSearch = filterState.stationSearch || '';

            // Restore pagination
            self.$scope.pageSize = filterState.pageSize || 10;

            // Apply filters
            self.$scope.updateFilter();

            // Set page after filter is applied
            self.$scope.setPage(filterState.currentPage || 1);
          }
        } catch (e) {
          console.error('Error restoring filter state:', e);
        }
      });

    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.getJurisdictionList();


      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })


  }

  loadSubmissions() {
    // Return the promise so we can chain operations after it completes
    return this.fetch.getAllItems(`api/data/submissions/get-submissions`)
      .then(response => {
        console.log(response);
        this.$scope.rowCollection = response.data;
        this.$scope.rowCollection = this.initializeSubmissions(response.data);
        this.$scope.filteredResults = response.data || [];
        this.$scope.totalItems = this.$scope.filteredResults.length;

        // Only initialize selected filters if we don't have saved state
        // (The saved state will be applied after this function completes)
        if (!localStorage.getItem('submissionsFilterState')) {
          this.$scope.selectedStatuses = {};
          this.$scope.selectedTypes = {};
          this.$scope.selectedJurisdictions = {};
          this.$scope.selectedStations = {};
          this.$scope.selectedPolicies = {};
        }

        // Function to extract unique values from a property
        const extractUniqueValues = (property) => {
          const uniqueMap = {};
          this.$scope.rowCollection.forEach(item => {
            if (item[property]) {
              uniqueMap[item[property]] = true;
            }
          });
          return Object.keys(uniqueMap);
        };

        // Store all available options from the original data
        this.$scope.allStatuses = extractUniqueValues('status');
        this.$scope.allTypes = extractUniqueValues('submission_policy_type');
        this.$scope.allPolicies = extractUniqueValues('submission_policy_name');
        this.$scope.allJurisdictions = extractUniqueValues('jurisdiction');
        this.$scope.allStations = extractUniqueValues('station_name');

        // Set the initial filter options to show all available options
        this.$scope.statuses = this.$scope.allStatuses;
        this.$scope.types = this.$scope.allTypes;
        this.$scope.uniquePolicies = this.$scope.allPolicies;
        this.$scope.uniqueJurisdictions = this.$scope.allJurisdictions;
        this.$scope.uniqueStations = this.$scope.allStations;

        // Use a local variable to hold the context
        const self = this;

        // Function to handle checkbox changes
        this.$scope.handleCheckboxChange = function (filterType, value) {
          // Check if the checkbox is being unchecked
          if (!self.$scope[filterType][value]) {
            // Reset the filter for the unchecked value
            delete self.$scope[filterType][value];
          }

          // Update the filtered results
          self.$scope.updateFilter();

          // Save current filter state to localStorage
          self.$scope.saveFilterState();
        };

        // Function to save filter state
        this.$scope.saveFilterState = function () {
          const filterState = {
            selectedStatuses: self.$scope.selectedStatuses,
            selectedTypes: self.$scope.selectedTypes,
            selectedPolicies: self.$scope.selectedPolicies,
            selectedJurisdictions: self.$scope.selectedJurisdictions,
            selectedStations: self.$scope.selectedStations,
            statusSearch: self.$scope.statusSearch,
            typeSearch: self.$scope.typeSearch,
            policySearch: self.$scope.policySearch,
            jurisdictionSearch: self.$scope.jurisdictionSearch,
            stationSearch: self.$scope.stationSearch,
            currentPage: self.$scope.currentPage,
            pageSize: self.$scope.pageSize
          };

          localStorage.setItem('submissionsFilterState', JSON.stringify(filterState));
        };

        // Function to clear all filters
        this.$scope.clearFilters = function () {
          // Clear all filter selections
          self.$scope.selectedStatuses = {};
          self.$scope.selectedTypes = {};
          self.$scope.selectedPolicies = {};
          self.$scope.selectedJurisdictions = {};
          self.$scope.selectedStations = {};

          // Clear all search fields
          self.$scope.statusSearch = '';
          self.$scope.typeSearch = '';
          self.$scope.policySearch = '';
          self.$scope.jurisdictionSearch = '';
          self.$scope.stationSearch = '';

          // Reset date filter if it exists
          self.$scope.selectedDate = null;

          // Update filtered results
          self.$scope.updateFilter();

          // Reset to page 1
          self.$scope.setPage(1);

          // Clear saved filter state
          localStorage.removeItem('submissionsFilterState');
        };

        // Function to filter the results
        this.$scope.updateFilter = function () {
          console.log('Updating filter...')
          if (!self.$scope.rowCollection) {
            self.$scope.filteredResults = [];
            self.$scope.totalItems = 0;
            self.$scope.setPage(1);
            return;
          }
          // Filter the results based on selected filters
          self.$scope.filteredResults = self.$scope.rowCollection.filter(self.$scope.filterFunction);
          self.$scope.totalItems = self.$scope.filteredResults.length; // Update total items
          self.$scope.setPage(1); // Reset to page 1 after filtering
          console.log('Filtered Results:', self.$scope.filteredResults);
        };

        this.$scope.filterFunction = function (item) {
          // Check if no filters are selected at all
          if (Object.keys(self.$scope.selectedStatuses).length === 0 &&
            Object.keys(self.$scope.selectedTypes).length === 0 &&
            Object.keys(self.$scope.selectedPolicies).length === 0 &&
            Object.keys(self.$scope.selectedJurisdictions).length === 0 &&
            Object.keys(self.$scope.selectedStations).length === 0 &&
            !self.$scope.selectedDate) {
            return true; // Show all items if no filters are selected
          }

          // Check if any status is selected and if the item matches any selected status
          const hasStatusFilter = Object.keys(self.$scope.selectedStatuses).length > 0;
          const isStatusSelected = !hasStatusFilter || self.$scope.selectedStatuses[item.status] === true;

          // Check if any type is selected and if the item matches any selected type
          const hasTypeFilter = Object.keys(self.$scope.selectedTypes).length > 0;
          const isTypeSelected = !hasTypeFilter || self.$scope.selectedTypes[item.submission_policy_type] === true;

          // Check if any policy is selected and if the item matches any selected policy
          const hasPolicyFilter = Object.keys(self.$scope.selectedPolicies).length > 0;
          const isPolicySelected = !hasPolicyFilter || self.$scope.selectedPolicies[item.submission_policy_name] === true;

          // Check if any jurisdiction is selected and if the item matches any selected jurisdiction
          const hasJurisdictionFilter = Object.keys(self.$scope.selectedJurisdictions).length > 0;
          const isJurisdictionSelected = !hasJurisdictionFilter || self.$scope.selectedJurisdictions[item.jurisdiction] === true;

          // Check if any station is selected and if the item matches any selected station
          const hasStationFilter = Object.keys(self.$scope.selectedStations).length > 0;
          const isStationSelected = !hasStationFilter || self.$scope.selectedStations[item.station_name] === true;

          // Check if date filter is applied and if the item matches the selected date
          const hasDateFilter = self.$scope.selectedDate !== undefined && self.$scope.selectedDate !== null;
          const isDateMatch = !hasDateFilter || new Date(item.submitted_date).toDateString() === new Date(self.$scope.selectedDate).toDateString();

          // Check if search term is applied and if the item matches the search
          const hasSearchFilter = self.$scope.statusSearch && self.$scope.statusSearch.trim() !== '';
          const isSearchMatch = !hasSearchFilter || (item.name && item.name.toLowerCase().includes(self.$scope.statusSearch.toLowerCase()));

          // Show the item if it matches ALL active filter categories
          // Within each category, we use OR logic (e.g., if any selected status matches)
          return isStatusSelected && isTypeSelected && isPolicySelected && isJurisdictionSelected && isStationSelected && isDateMatch && isSearchMatch;
        };

        // Watch for changes in the search fields and update filtered results
        this.$scope.$watch('statusSearch', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        });

        // Watch for changes in the selected statuses
        this.$scope.$watch('selectedStatuses', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        }, true);

        // Watch for changes in the selected types
        this.$scope.$watch('selectedTypes', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        }, true);

        // Watch for changes in the selected policies
        this.$scope.$watch('selectedPolicies', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        }, true);

        // Watch for changes in the selected jurisdictions
        this.$scope.$watch('selectedJurisdictions', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        }, true);

        // Watch for changes in the selected stations
        this.$scope.$watch('selectedStations', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        }, true);

        // Watch for changes in the selected date
        this.$scope.$watch('selectedDate', function (newValue) {
          self.$scope.updateFilter();
          self.$scope.saveFilterState();
        });

        // Initialize filtered results
        this.$scope.updateFilter();
        //set page after filter
        this.$scope.setPage(1);
      })
      .catch(err => {
        console.log(err);
        this.$scope.filteredResults = [];

        this.$scope.totalItems = 0;
        this.$scope.setPage(1);

      });
  }

  initializeSubmissions(submissions) {
    const vm = this;
    return submissions.map(function (item) {
      item.excludeFromScoring = vm.excludedPolicies.includes(item.submission_policy_name);
      return item;
    });
  }

}

export default angular.module('appApp.submissions', [uiRouter, 'smart-table'])
  .config(routes)
  .component('submissions', {
    template: require('./submissions.html'),
    controller: SubmissionsComponent,
    controllerAs: 'submissionsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/compliance/submissions/submissions.component.js